import { easeOutCubic, easeOutExpo } from "easing-utils";
import { rgb, rgba } from "../utils/color";
import { __check_circle_collision, CircularButtonBase } from "./button";
import { ScreenState } from "./screen";

export class Word extends CircularButtonBase{
  initialScreenStateTime = null;// If game is paused, this and `initialPlayerPosition` must be reset too.
  currentPlayerPosition = null;// For internal use, no touching!
  outroDuration = 500;//This changes after it is pressed, if it is even pressed.
  clickHandlerRan = false;
  missHandlerRan = false;
  constructor(word, x, y, startTime, duration, currentPlayerPosition, introDuration, onClick, onMiss, configureCanvas){
    super(x,y,50,onClick,configureCanvas)
    this.word = word;
    this.startTime = startTime;
    this.duration = duration;
    this.endTime = startTime + duration;
    this.initialPlayerPosition = currentPlayerPosition;//Not in use
    this.introDuration = introDuration || 1000;
    this.onMiss = onMiss;
  }
  /**
   * Checks if cursors are intersecting object.
   * @param {Cursor[]} cursors A list of cursors to check
   * @param {ScreenState} screenState The current state of the screen
   * @returns {Boolean} true if there are cursors intersecting the object.
   */
  checkHover(cursors, screenState){
    const [newX, newY, newRadius] = [screenState.X(this.x), screenState.Y(this.y), this.WordLength ? Math.max(screenState.S(this.radius), this.WordLength) : screenState.S(this.radius)];
    for (let i = 0; i < cursors.length; i++){
      if (__check_circle_collision(cursors[i].x, cursors[i].y, cursors[i].radius, newX, newY, newRadius)){//Possible scalling problem with this.WordLength
        return true;
      }
    }
  }
  /**
   * Update the object's state based on the state of the cursor.
   * @param {Cursor[]} cursors The list of cursor objects to check if the button is colliding with the cursor. 
   * @param {ScreenState} screenState The current state of the screen
   */
  updateHover(cursors, screenState){
    const animationStep = screenState.animationStep
    if(!this.initialScreenStateTime){
      this.initialScreenStateTime = animationStep;
    }
    // if (!this.currentPlayerPosition){
    //   this.currentPlayerPosition = this.initialPlayerPosition + (animationStep - this.initialScreenStateTime);
    // }

    // this.currentPlayerPosition = this.initialPlayerPosition + (animationStep - this.initialScreenStateTime);
    
    if (!this.clickHandlerRan && this.currentPlayerPosition >= this.startTime && this.currentPlayerPosition <= this.endTime && this.checkHover(cursors, screenState)){
      this.onClick(this);
      this.clickHandlerRan = true;
      if (true || this.duration <= 200){
        this.outroDuration = Math.max(this.endTime - this.currentPlayerPosition, this.outroDuration);
        this.endTime = this.currentPlayerPosition;
      }
      return true;
    }
    return false;
  }
  /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  configure(screenState){
  }

  /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  render(screenState) {
    if(!this.initialScreenStateTime){
      this.initialScreenStateTime = screenState.animationStep;
    }
    const baseFontSize = screenState.S(36)
    this.currentPlayerPosition = screenState.playerPosition || 0;
    super.render(screenState);
    // this.currentPlayerPosition = this.initialPlayerPosition + (screenState.animationStep - this.initialScreenStateTime);
    // if (!this.currentPlayerPosition){
    // }
    // screenState.canvasCtx.font = `${baseFontSize}px Yusei Magic`;
    screenState.canvasCtx.textAlign = 'center';
    screenState.canvasCtx.textBaseline = 'middle';
    if (!this.WordLength){
      this.WordLength = (screenState.canvasCtx.measureText(this.word).width + 30)/2;
    }
    const xPos = screenState.X(this.x);
    const yPos = screenState.Y(this.y);
    const radius = Math.max(screenState.S(this.radius), this.WordLength);
    screenState.canvasCtx.lineWidth = screenState.S(3);
    screenState.canvasCtx.strokeStyle = rgb(228, 255, 26);
    if(this.currentPlayerPosition <= this.startTime){// Word before specified timing
      screenState.canvasCtx.font = `${baseFontSize}px Yusei Magic`;
      // console.log(this.currentPlayerPosition)
      // NOTE: This progress runs backwards, 0 when currentPos == startTime
      if (this.startTime - this.currentPlayerPosition >= this.introDuration){
        return;
      }
      const introProgress = easeOutCubic(Math.min((this.startTime - this.currentPlayerPosition)/this.introDuration, 1));
      const color = rgb(15,223,23);
      // const strokeColor = rgba(0, 0, 255, 1);
      const transitionProgress = easeOutExpo(1-introProgress)
      screenState.canvasCtx.globalAlpha = transitionProgress;
      
      const outer_radius = (radius*3)*introProgress + radius;
      screenState.canvasCtx.strokeStyle = rgba(228, 255, 26, 1-introProgress);

      screenState.canvasCtx.fillStyle = color;
      // screenState.canvasCtx.strokeColor = strokeColor;
      
      screenState.canvasCtx.beginPath();
      screenState.canvasCtx.arc(xPos, yPos, radius, 0,2*Math.PI);
      screenState.canvasCtx.fill();

      screenState.canvasCtx.shadowColor = rgb(228, 255, 26);
      screenState.canvasCtx.shadowBlur = 15;
      screenState.canvasCtx.beginPath();
      screenState.canvasCtx.arc(xPos, yPos, outer_radius, 0,2*Math.PI);
      screenState.canvasCtx.stroke();
      screenState.canvasCtx.shadowBlur = 0;

      screenState.canvasCtx.fillStyle = rgba(255,255,255, transitionProgress);
      screenState.canvasCtx.fillText(this.word, xPos, yPos);
      screenState.canvasCtx.globalAlpha = 1;
    }
    else if (this.currentPlayerPosition >= this.endTime){// Word after specified timing
      // console.log(`Completed: ${this.word}`)
      // this.destroy();
      // return;
      const outroProgress = 1-easeOutCubic(Math.min((this.currentPlayerPosition - this.endTime)/this.outroDuration, 1));
      if (!this.missHandlerRan && !this.clickHandlerRan && this.onMiss){
        this.onMiss();
        this.missHandlerRan = true;
      }
      if (outroProgress <= 0){
        // console.log(`Completed: ${this.word}`)
        this.destroy();
        return;
      }
      screenState.canvasCtx.font = `${this.clickHandlerRan ? baseFontSize + baseFontSize*2*(1-outroProgress) : baseFontSize}px Yusei Magic`;
      const color = this.clickHandlerRan ? rgb(168, 234, 141) : rgb(235, 94, 85);
      screenState.canvasCtx.globalAlpha = outroProgress;
      screenState.canvasCtx.fillStyle = color;
      // screenState.canvasCtx.strokeColor = rgba(0,0,255,1);
      screenState.canvasCtx.beginPath();
      screenState.canvasCtx.arc(xPos, yPos, this.clickHandlerRan ?  radius*outroProgress: radius, 0,2*Math.PI);
      screenState.canvasCtx.fill();

      // screenState.canvasCtx.beginPath();
      // screenState.canvasCtx.arc(xPos, yPos, radius, 0,2*Math.PI);
      // screenState.canvasCtx.stroke();

      let fadeProgress;
      
      if (this.clickHandlerRan){
        fadeProgress = easeOutExpo(outroProgress)
        screenState.canvasCtx.globalAlpha = fadeProgress;
      }
      else{
        fadeProgress = outroProgress;
      }

      screenState.canvasCtx.shadowBlur = 15*(1-outroProgress);
      screenState.canvasCtx.fillStyle = rgba(255,255,255, fadeProgress);
      screenState.canvasCtx.shadowColor = rgb(255,255,255);
      screenState.canvasCtx.fillText(this.word, xPos, yPos);
      screenState.canvasCtx.shadowBlur = 0;
      screenState.canvasCtx.globalAlpha = 1;
    }
    else{// Word within specified timing
      screenState.canvasCtx.font = `${baseFontSize}px Yusei Magic`;
      const color = this.clickHandlerRan ? rgb(15,223,23,1) : rgb(232, 170, 20);
      screenState.canvasCtx.fillStyle = color;
      // screenState.canvasCtx.strokeColor = rgba(0,0,255,1);
      screenState.canvasCtx.beginPath();
      screenState.canvasCtx.arc(xPos, yPos, radius, 0,2*Math.PI);
      screenState.canvasCtx.fill();

      screenState.canvasCtx.shadowColor = rgb(228, 255, 26);
      screenState.canvasCtx.shadowBlur = 15;
      screenState.canvasCtx.beginPath();
      screenState.canvasCtx.arc(xPos, yPos, radius, -Math.PI/2,(2*Math.PI*(1-((this.currentPlayerPosition - this.startTime)/this.duration)))-Math.PI/2);
      screenState.canvasCtx.stroke();
      screenState.canvasCtx.shadowBlur = 0;

      screenState.canvasCtx.fillStyle = rgb(255,255,255);
      screenState.canvasCtx.fillText(this.word, xPos, yPos);
    }

    
  }
}